import { RAQ_PAGE_TYPE, RaqPageType } from '@components/utils/constants'
import DetailsPageWrapper from '@modules/detailsPage/DetailsPageWrapper'
import AccommodationPageTopSection from '@modules/detailsPage/topSections/AccommodationPageTopSection'
import ActivityPageTopSection from '@modules/detailsPage/topSections/ActivityPageTopSection'
import LocationPageTopSection from '@modules/detailsPage/topSections/LocationPageTopSection'
import { RaQFormType } from 'pages/things-to-do/[...slug]'
import { useMemo } from 'react'
import { ITopNavigationResponse } from '../../types/commonResponses'
import {
  IAccommodationResponse,
  IActivityResponse,
  ILocationResponse,
  IPackageResponse,
  IRegionResponse,
} from '../../types/modelResponses'
import AccommodationOrActivityPageMainSection from '@modules/detailsPage/mainSections/AccommodationOrActivityPageMainSection'
import PackagePageTopSection from '@modules/detailsPage/topSections/PackagePageTopSection'
import PackagePageMainSection from '@modules/detailsPage/mainSections/PackagePageMainSection'
import DetailsPageSectionsWrapper from '@modules/detailsPage/DetailsPageSectionsWrapper'

interface IDetailsPage {
  data:
    | IAccommodationResponse
    | ILocationResponse
    | IPackageResponse
    | IActivityResponse
  region?: IRegionResponse
  allPackages?: IPackageResponse | IPackageResponse[]
  allLocations?: ILocationResponse | ILocationResponse[]
  topNavigation: ITopNavigationResponse
  raqFormType: RaQFormType
  pageType: RaqPageType
  openViewAllActivities?: (shouldOpen: boolean) => void
  openViewAllAccommodations?: (shouldOpen: boolean) => void
  viewAllActivities?: boolean
  viewAllAccommodations?: boolean
}

function DetailsPage({
  data, // styledParser needed for Overview, Long_Description
  region,
  allPackages,
  allLocations,
  topNavigation,
  raqFormType,
  pageType,
  openViewAllActivities,
  openViewAllAccommodations,
  viewAllActivities,
  viewAllAccommodations,
}: IDetailsPage): JSX.Element {
  const pageSections = useMemo(() => {
    if (
      pageType === RAQ_PAGE_TYPE.ACCOMMODATION ||
      pageType === RAQ_PAGE_TYPE.ACTIVITY
    ) {
      return (
        <>
          {pageType === RAQ_PAGE_TYPE.ACCOMMODATION ? (
            <AccommodationPageTopSection data={data} region={region} />
          ) : (
            <ActivityPageTopSection data={data} />
          )}
          <AccommodationOrActivityPageMainSection
            data={data}
            allPackages={allPackages}
            allLocations={allLocations}
            pageType={pageType}
          />
        </>
      )
    } else if (pageType === RAQ_PAGE_TYPE.PACKAGE) {
      const currentData = data as IPackageResponse

      return (
        <>
          {currentData.locations ? (
            <PackagePageTopSection data={data as IPackageResponse} />
          ) : (
            <LocationPageTopSection data={data as ILocationResponse} />
          )}
          {/*
          For each locations on 
          https://cms.devcrvtestingmm.com/admin/content-manager/collectionType/api::package.package/161
          get accommodations, activities and reviews
          https://cms.devcrvtestingmm.com/admin/content-manager/collectionType/api::location.location/10
          */}
          <PackagePageMainSection
            data={data as IPackageResponse | ILocationResponse}
            openViewAllActivities={
              openViewAllActivities as (shouldOpen: boolean) => void
            }
            openViewAllAccommodations={
              openViewAllAccommodations as (shouldOpen: boolean) => void
            }
            viewAllAccommodations={viewAllAccommodations}
            viewAllActivities={viewAllActivities}
          />
        </>
      )
    }
  }, [
    data,
    pageType,
    viewAllAccommodations,
    viewAllActivities,
    openViewAllAccommodations,
    openViewAllActivities,
  ])

  return (
    <DetailsPageWrapper data={data} pageType={pageType}>
      <DetailsPageSectionsWrapper
        data={data}
        topNavigation={topNavigation}
        raqFormType={raqFormType}
        pageType={pageType}
      >
        {pageSections}
      </DetailsPageSectionsWrapper>
    </DetailsPageWrapper>
  )
}

export default DetailsPage
